var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { HAWKINS_URL_PROD } from '../constants';
import { isObject } from './objectHelpers';
import { buildStringFromSegments } from './primitiveHelpers';
var EVENT_HANDLER_NAME_REGEX = new RegExp('^on[A-Z]');
/**
 * A customizable console logging call.
 * By default, does NOT log in production.
 */
export function logToConsole(message, _a) {
    var _b = _a === void 0 ? {} : _a, disabled = _b.disabled, displayName = _b.displayName, docsPath = _b.docsPath, _c = _b.level, level = _c === void 0 ? 'warn' : _c, _d = _b.printInProd, printInProd = _d === void 0 ? false : _d;
    if (disabled)
        return;
    if (printInProd || process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console[level](buildStringFromSegments([
            displayName && "[".concat(displayName, "]"),
            message,
            docsPath &&
                // Allow for linking to the root path of the docs site.
                "See ".concat(buildStringFromSegments([HAWKINS_URL_PROD, docsPath === true ? '' : docsPath], '/'), " for more info."),
            // Assume that the component allows logging to be disabled if it is populating `options.disabled`.
            typeof disabled === 'boolean' && 'Set `props.disableUsageWarnings=true` to disable this warning.',
        ]));
    }
}
/**
 * A function for detecting an object that represents a React component or element.
 */
export function isAssumedComponentOrElementObject(val) {
    // Assume that an object with a `$$typeof` property represents a React component or element
    // (fun reading: https://overreacted.io/why-do-react-elements-have-typeof-property/).
    return isObject(val) && Object.keys(val).includes('$$typeof');
}
/**
 * A function for detecting event handler props.
 */
export function isAssumedEventHandlerName(str) {
    return EVENT_HANDLER_NAME_REGEX.test(str);
}
/**
 * Performs a shallow merge of two objects with the following caveats:
 *   - The result is a new object. The arguments are NOT mutated.
 *   - All values in `objB` override the corresponding value in `objA` UNLESS the value in `objB` is `undefined`.
 *   - Assumed event handler functions are chained.
 */
export function mergeProps(objA, objB) {
    var result = __assign({}, objA);
    Object.entries(objB).forEach(function (_a) {
        var _b = __read(_a, 2), keyB = _b[0], valB = _b[1];
        if (valB === undefined)
            return;
        var valA = result[keyB];
        if (isAssumedEventHandlerName(keyB) && typeof valA === 'function' && typeof valB === 'function') {
            result[keyB] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                valA.apply(void 0, __spreadArray([], __read(args), false));
                valB.apply(void 0, __spreadArray([], __read(args), false));
            };
        }
        else {
            result[keyB] = valB;
        }
    });
    return result;
}
//# sourceMappingURL=componentHelpers.js.map